import { render } from "./ButtonRedPrimary.vue?vue&type=template&id=a79a4380"
import script from "./ButtonRedPrimary.vue?vue&type=script&lang=js"
export * from "./ButtonRedPrimary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__